import { useState, useEffect } from "react";
import linkedinPostsData from "../data/linkedinPosts.json";

interface LinkedInPost {
  id: number;
  title: string;
  image: string;
  url: string;
}

interface UseLinkedInPostsReturn {
  posts: LinkedInPost[];
  loading: boolean;
  error: string | null;
}

export const useLinkedInPosts = (): UseLinkedInPostsReturn => {
  const [posts, setPosts] = useState<LinkedInPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      setPosts(linkedinPostsData);
      setLoading(false);
    } catch (err) {
      setError("Failed to load posts");
      setLoading(false);
    }
  }, []);

  return {
    posts,
    loading,
    error,
  };
};
